import {DashboardDto} from '@generated/models'

import {Sex} from './medical'
import {Notification} from './notification'

export type Name = {
  firstName?: string | null
  secondName?: string | null
  title?: string | null
  knownBy?: string | null
}

export type BasicPatientData = {
  dateOfBirth?: string
  gender?: Sex
}

export enum PractitionerPatientEditDisabledReasonCode {
  NOT_IN_OWNED_CAMPAIGN = 'NOT_IN_OWNED_CAMPAIGN',
  PROTECTED_DEMOGRAPHICS = 'PROTECTED_DEMOGRAPHICS',
}

export type PractitionerPatientIdentityValues = {
  dateOfBirth?: string | null
  gender?: Sex | null
  phoneNumber?: string | null
}

export type PractitionerPatientIdentityCapability = {
  canEdit: boolean
  reasonCodes: PractitionerPatientEditDisabledReasonCode[]
}

export type Dashboard = Omit<DashboardDto, 'notifications'> & {
  notifications: Notification[]
}

export type {
  CompleteOnboardingStepRequest,
  IdentityDocumentsDto as IdentityDocuments,
  PatientForPractitionerDTO as PractitionersPatient,
  NameAndDateOfBirthDto as PatientNameAndDateOfBirth,
  PatientOnboardingDto as PatientOnboarding,
  PatientResponse as Patient,
  PatientShortDto as PatientShort,
  RequestMedicalRecordsRequest,
  SignupRequest as AddPatientRequest,
  UpdateUnitSystemDto as UpdateUnitSystemRequest,
  UpdateLanguageCodeDto as UpdateLanguageCodeRequest,
} from '@generated/models'

export {
  UnitSystem,
  SubscriptionStatus,
  PatientOnboardingStepStatus,
  OnboardingStep,
  LanguageCode,
} from '@generated/models'
